<template>
  <of-dialog :title="formTitle" @onCancel="cancel" :width="width">
    <div slot="content">
      <el-form label-width="120px" :model="dataForm">
        <el-form-item
          label="基础信息"
          style="background-color: #f8f8f9"
          label-width="80px"
        ></el-form-item>
        <el-row>
          <el-col :span="12">
            <el-form-item label="求助人姓名："
              >{{ dataForm.Name }}
            </el-form-item></el-col
          >
          <el-col :span="12">
            <el-form-item label="性别："
              >{{ showSex(dataForm.Sex) }}
            </el-form-item></el-col
          >
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="身份证号："
              >{{ dataForm.IdentityCard }}
            </el-form-item></el-col
          >
          <el-col :span="12">
            <el-form-item label="手机号："
              >{{ dataForm.Phone }}
            </el-form-item></el-col
          >
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="求助类型："
              >{{ dataForm.Type }}
            </el-form-item></el-col
          >
          <el-col :span="12">
            <el-form-item label="地址："
              >{{ dataForm.Address }}
            </el-form-item></el-col
          >
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="邮寄方式："
              >{{ showMailingType(dataForm.MailingType) }}
            </el-form-item></el-col
          >
          <el-col :span="12" v-if="dataForm.MailingType === 1">
            <el-form-item label="快递公司："
              >{{ dataForm.ExpressCompany | nullStr}}
            </el-form-item></el-col
          >
        </el-row>
         <el-row  v-if="dataForm.MailingType === 1">
          <el-col :span="12">
            <el-form-item label="快递单号："
              >{{ dataForm.ExpressNo | nullStr}}
            </el-form-item></el-col
          >
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item label="附件：">
              <!-- <of-upload
                class="upload-demo"
                list-type="fileList"
                @onPreview="onFilePreview"
                :fileList="fileList"
                :class="{ hideFile: true }"
              >
              </of-upload> -->
             <el-image 
                  style="width: 100px; height: 100px"
                  :src="'/api/File/Download?Id='+dataForm.Files" 
                  :preview-src-list="['/api/File/Download?Id='+dataForm.Files]">
              </el-image>
            </el-form-item
          ></el-col>
        </el-row>
      </el-form>
    </div>
  </of-dialog>
</template>
<script>
import OfDialog from "@/components/controls/of_dialog/of_dialog";
import OfUpload from "@/components/controls/of_upload/of_upload";
import { saveAs } from "file-saver";
import api from "@/modules/zjrc/api";

export default {
  name: "edit",
  props: {
    id: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      formTitle: "查看详情",
      width: "55%",
      dataForm: {},
      fileList:[],//附件数组
    };
  },
  components: {
    OfDialog,
    OfUpload
  },
  mounted() {
    let that = this;
    that.loadData();
  },
  computed: {
    showSex() {
      return (data) => {
        return data == 0 ? "女" : "男";
      };
    },
     showMailingType() {
      return (data) => {
       if (data === 0) {
           return '未处理'
       }else if(data === 1) {
           return '快递邮寄'
       }else {
           return '上门领取'
       }
      };
    },
  },
  methods: {
    //初始化数据
    loadData() {
      let that = this;
      let params = { Id: that.id };
      api.QuerySeekHelpApplyById(params).then((res) => {
        if (res.data.Code == 0) {
          that.dataForm = res.data.Data;
            // that.getlistfile();
        }
      });
    },
    //取消
    cancel() {
      this.$emit("formSeekCallBack", null);
    },
    //加载文件
    getlistfile() {
      let that = this;
      if (that.dataForm.Files === undefined || that.dataForm.Files === null) {
        return;
      }
      let params = { Id: that.dataForm.Files };
      api.QueryBigSickApplyFileByIds(params).then((res) => {
        if (res.data.Code == 0) {
          let fileList = res.data.Data;
          fileList.forEach((item) => {
            that.fileList.push({url:item.Url,name:item.FileName});
          });
        }
      });
    },
    //下载附件
    onFilePreview(file) {
      saveAs(file.url, file.name);
    },
  },
};
</script>
<style scoped>
.of-dialog >>> .el-button--primary {
  display: none;
}

.of-dialog >>> .el-button--default {
  display: none;
}
.el-form >>> .el-form-item__label {
  font-weight: 500;
}

.label-title {
  padding: 10px 0;
}
</style>

<style>
.hideFile .el-upload--fileList {
  display: none !important;
}
</style>